import { forwardRef } from "react";
import type { ReactNode } from "react";
import {
  Menu,
  type MenuItem,
  type MenuProps,
} from "src/components/Menu/Menu.tsx";

export type ContextItemModel = MenuItem;
export type DataGridContextMenu = MenuProps;

export const DataGridContextMenu = forwardRef<
  HTMLDivElement,
  {
    items: ContextItemModel[];
    customContent?: ReactNode;
    onClose?: () => void;
  }
>(({ items, customContent, onClose, ...rest }, ref) => {
  return (
    <Menu customContent={customContent} ref={ref} items={items} {...rest} />
  );
});
